import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild, HostListener } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';

import { ExcelService } from './../../../services/infrastructure/excel.service';
import { tableHeader, eventDetail } from '../../../models/AccountDetailsVM';

@Component({
  selector: 'app-efulfillmenttable',
  templateUrl: './efulfillmentTable.component.html',
  styleUrls: ['./efulfillmentTable.component.scss']
})

export class efulfillmentTableComponent implements AfterViewInit {
  headerDS: tableHeader[] = [];
  bodyDS: any[] = [];
  paginatorDS: any[] = [];
  indeterminateCheck = false;
  allChecked = false;
  isAllCheckBoxEnable = false;
  pageName: string;
  isCellColorEnable: boolean;
  noRecordLength: string;
  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;
  // set and get input field for header
  @Input()
  set propHeaderDS(headers: tableHeader[]) {
    this.headerDS = headers;
    if (this.headerDS.length > 0) {
      this.noRecordLength = this.headerDS.length.toString();
      this.isAllCheckBoxEnable = this.headerDS.find(e => e.headertxt == 'checkboxHeader') != undefined ? true : false;
    }
  }
  get propHeaderDS(): tableHeader[] {
    return this.headerDS;
  }

  // set the page name
  @Input()
  set propPageName(val: string) {
    this.pageName = val;
  }

  get propPageName(): string {
    return this.pageName;
  }

  @Input()
  set propIsCellColorEnable(val: boolean) {
    this.isCellColorEnable = val;
  }

  // set and get input field for table data source
  @Input()
  set propBodyDS(dataList: any[]) {
    this.bodyDS = dataList;
    if (this.bodyDS) {
      if (this.bodyDS.length > 0) {
        this.productPaginator.firstPage();
      }
      this.length = this.bodyDS.length;
      this.setPaginatorDS();
      this.partialCheckHeader();
      this.allCheckHeader();
    }
  }
  get propBodyDS(): any[] {
    return this.bodyDS;
  }

  @Input()
  set propExport(val: boolean) {
    // this Export functionality independent with val, we use it  to pass or indicate
    // export button click from parent to child
    this.exportAsXLSX();
  }

  // row click event emitter
  @Output()
  RowClick: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  // cell click event emitter
  @Output()
  CellClick: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  @Output()
  RowChecked: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  // row click event emitter
  @Output()
  AllRowChecked: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  constructor(public excelService: ExcelService) {
  }

  // MatPaginator Inputs
  length = 0;
  pageSize = 50;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  // set paginator on change
  setPaginatorDS() {
    const recordToSkip = this.pageSize * this.pageIndex;
    this.paginatorDS = this.bodyDS.slice(recordToSkip, recordToSkip + this.pageSize);
  }

  // set MatPaginator Inputs on paginator change
  onPaginatorChange(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.setPaginatorDS();
  }

  sortData(sort: Sort) {
    const data = this.bodyDS.slice();

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.bodyDS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return compare(a[sort.active], b[sort.active], isAsc);
    });

    this.setPaginatorDS();
    this.partialCheckHeader();
    this.allCheckHeader();
  }

  exportAsXLSX() {
    if (this.pageName == 'QuickOrder') {
      if (this.bodyDS && this.bodyDS.length > 0) {
        this.excelService.exportAsExcelFile(this.bodyDS, 'OrderDetailReport');
      }
    }
    else {
      const exportData = [];
      if (this.bodyDS && this.bodyDS.length > 0) {
        this.bodyDS.forEach(x => {
          exportData.push({
            Account: x.account,
            AccountName: x.accountName,
            AccountType: x.accountTypeDescription,
            City: x.city,
            State: x.state
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'Account');
      }
    }
  }

  // emit row click event
  onRowClicked(e: any, rowData: any, index: any) {
    const eventData = new eventDetail();
    eventData.eventData = e;
    eventData.event = 'RowClick';
    eventData.rowData = rowData;
    if (rowData.isAccountRowSelected !== undefined && !rowData.isAccountRowSelected) {
      rowData.isAccountRowSelected = true;
      this.paginatorDS.forEach((value, i) => {
        if (i !== index) {
          value.isAccountRowSelected = false;
        }
      });
    }
    this.RowClick.emit(eventData);
  }
  // emit row click event
  onCellClicked(e: any, rowData: any, cellHeader: any) {
    const eventData = new eventDetail();
    eventData.event = 'Cell Click :' + cellHeader;
    eventData.eventData = e;
    eventData.rowData = rowData;
    this.CellClick.emit(eventData);
  }

  rowChecked(e: any, rowData: any) {
    const eventData = new eventDetail();
    eventData.event = 'rowChecked';
    eventData.eventData = e;
    eventData.rowData = rowData;

    this.partialCheckHeader();
    this.allCheckHeader();

    this.RowChecked.emit(eventData);
  }

  allRowChecked(e: any) {
    const elCheckBox = this.getHeaderCheckBox();
    if (elCheckBox) {
      this.bodyDS.forEach(x => {
        x[elCheckBox.columnfield] = e.checked;
      });
      this.indeterminateCheck = false;
    }

    const eventData = new eventDetail();
    eventData.event = 'allRowChecked';
    eventData.eventData = e;
    this.AllRowChecked.emit(eventData);
  }

  getHeaderCheckBox(): tableHeader {
    const filteredHeader = this.headerDS.filter(e => e.headertxt == 'checkboxHeader');
    const elCheckBox = filteredHeader[0];
    return elCheckBox;
  }

  partialCheckHeader() {
    const elCheckBox = this.getHeaderCheckBox();
    if (elCheckBox) {
      const checkedRow = this.paginatorDS.filter(x => x[elCheckBox.columnfield] === true);
      if (checkedRow.length > 0) {
        this.indeterminateCheck = true;
      }
      else {
        this.indeterminateCheck = false;
      }
    }
  }

  allCheckHeader() {
    const elCheckBox = this.getHeaderCheckBox();
    if (elCheckBox) {
      const checkedRow = this.bodyDS.filter(x => x[elCheckBox.columnfield] === true);
      if (checkedRow.length != 0 && (checkedRow.length == this.bodyDS.length)) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Set Account Table Height
  setAccountTableHeight() {
    // const tableHeight = window.innerHeight - $('.accountPageTopFilter').outerHeight() - $('.tableTopSec').outerHeight() - 220;
    // $('.tableComponentOuter').css('max-height', tableHeight + 'px');

    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.accountPageTopFilter').outerHeight() - $('.tableTopSec').outerHeight() - 220;
      $('.tableComponentOuter').css('max-height', tableHeight + 'px');
    }, 100);
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
